<template>
  <LineChart v-bind:title="title" v-bind:data="data" v-bind:labels="labels" />
</template>

<script>
import LineChart from "@/components/management/statistics/common/LineChart";
import { getAccessByTimezoneChartData } from "@/api/statisticsV2";

export default {
  components: {
    LineChart,
  },
  data() {
    return {
      title: "Access by TimeZone",
      data: [],
      labels: [],
    };
  },
  methods: {
    async getData(startDate, endDate) {
      let loader = this.$loading.show({});
      try {
        let response = await getAccessByTimezoneChartData(startDate, endDate);
        this.labels = response.data.name;
        this.data = response.data.count;
      } finally {
        loader.hide();
      }
    },
  },
};
</script>

<style></style>
